export enum ResourceType {
  Model = "Model",
  Artifact = "Artifact",
  File = "File",
}
